import { VesselTypeEnum } from '@deckee/api-app-main';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../services/store';
import {
  fetchMarketplaceSafetyItems,
  getSuggestedSafetyItems,
} from '../../../../services/store/modules/marketplace';
import { selectSelectedVessel } from '../../../../services/store/modules/vessels';
import { getPrepareLocation } from '../../../../services/store/modules/app-controls';

const useRecommendedSafetyGear = () => {
  const dispatch = useAppDispatch();
  const { latitude, longitude, intendedAreaWaterBodyKey } =
    useSelector(getPrepareLocation);
  const [initialLoadComplete, setInitialLoadComplet] = useState(false);
  const selectedVessel = useSelector(selectSelectedVessel);
  const allSafetyItems = useSelector(getSuggestedSafetyItems);

  const mandatorySafetyItems = allSafetyItems.filter((i) => i.mandatory);
  const recommendedSafetyItems = allSafetyItems.filter((i) => !i.mandatory);

  useEffect(() => {
    const dispatchFetchMarketplaceSafetyItems = async () => {
      // Only fetch items when we have a type, length and area key
      if (
        intendedAreaWaterBodyKey &&
        selectedVessel?.watercraft_type &&
        selectedVessel?.vessel_length
      ) {
        let length: string | number | undefined = selectedVessel?.vessel_length;
        if (length && selectedVessel?.length_units === 'ft') {
          length = parseFloat(length) * 0.3048;
        }

        await dispatch(
          fetchMarketplaceSafetyItems({
            areaWaterBodyKey: intendedAreaWaterBodyKey || '',
            vesselType:
              (selectedVessel?.watercraft_type
                ?.toLowerCase()
                .replace(' ', '-') as VesselTypeEnum) || '',
            vesselLength: `${length}`,
          }),
        ).unwrap();
      }
      setInitialLoadComplet(true);
    };

    dispatchFetchMarketplaceSafetyItems();
  }, [
    dispatch,
    intendedAreaWaterBodyKey,
    latitude,
    longitude,
    selectedVessel,
    selectedVessel?.vessel_length,
    selectedVessel?.watercraft_type,
  ]);

  return {
    initialLoadComplete,
    allSafetyItems,
    mandatorySafetyItems,
    recommendedSafetyItems,
  };
};

export default useRecommendedSafetyGear;
